module.exports = __webpack_public_path__ + "img/icon_x.4f9da605.svg";